import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useGetProduct } from "../../hooks/useGetProduct";
import useDevice from "../../hooks/useDevice";
import "./Ebook.css";

function Ebook() {
  const token = useSelector((state) => state.auth.token);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { slug } = useParams();
  const { isMobile } = useDevice();

  const { data: product, isLoading, error } = useGetProduct(slug, user?.id, token);

  const hasAccess = product?.meta_data?.some(
    (meta) => meta.key === "_ebook_stream_url" && !!meta.value
  );

  const ebookUrl = product?.meta_data?.find(
    (item) => item.key === "_ebook_stream_url"
  )?.value;

  useEffect(() => {
    if (product && !hasAccess) {
      navigate("/");
    }
  }, [product, hasAccess, navigate]);

  if (isLoading) {
    return (
      <main className="Ebook">
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          color: "#fff"
        }}>
          Loading...
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="Ebook">
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          color: "#fff"
        }}>
          Error loading ebook
        </div>
      </main>
    );
  }

  if (!hasAccess) {
    return null;
  }

  const buttonStyles = {
    position: "absolute",
    top: isMobile ? "10px" : "20px",
    left: isMobile ? "10px" : "20px",
    zIndex: 1000,
    background: "rgba(0, 0, 0, 0.7)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: isMobile ? "6px" : "8px",
    padding: isMobile ? "8px 12px" : "10px 16px",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "6px" : "8px",
    fontSize: isMobile ? "12px" : "14px",
    fontWeight: "500",
    transition: "all 0.2s ease",
  };

  return (
    <main className="Ebook">
      <button
        onClick={() => navigate(`/product/${slug}`)}
        style={buttonStyles}
      >
        <ArrowLeft size={isMobile ? 16 : 18} />
        {!isMobile && "Back"}
      </button>
      <iframe
        allowFullScreen
        allow="clipboard-write"
        scrolling="no"
        className="fp-iframe"
        src={ebookUrl}
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          border: 0,
          top: 0,
          left: 0,
          background: "#1a1a1a",
        }}
        title="View Ebook"
      ></iframe>
    </main>
  );
}

export default Ebook;
